var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36906",
    "data-name": "Group 36906",
    transform: "translate(13058 -9705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c7d2221b43fdf0df9991d38ba129c310",
    transform: "translate(-13056.861 9706.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23594",
    "data-name": "Path 23594",
    d: "M.2,14.058l1.814,1.814a.679.679,0,0,0,.96,0,2.037,2.037,0,1,1,2.88,2.881.679.679,0,0,0,0,.96l1.814,1.814a.679.679,0,0,0,.96,0l12.9-12.9a.678.678,0,0,0,0-.96L19.711,5.853a.679.679,0,0,0-.96,0,2.037,2.037,0,1,1-2.88-2.881.679.679,0,0,0,0-.96L14.057.2a.679.679,0,0,0-.96,0L.2,13.1a.678.678,0,0,0,0,.96ZM8.825,6.391l.538.538a.679.679,0,0,0,.96-.96l-.538-.538,3.792-3.792.9.9a3.4,3.4,0,0,0,4.7,4.705l.9.9-3.792,3.792-.538-.538a.679.679,0,1,0-.96.96l.538.538L8.146,20.086l-.9-.9a3.4,3.4,0,0,0-4.7-4.705l-.9-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23595",
    "data-name": "Path 23595",
    d: "M31.878,22.838a.679.679,0,0,0,.96-.96l-.679-.679a.679.679,0,1,0-.96.96l.679.679ZM33.236,24.2l.679.679a.679.679,0,0,0,.96-.96l-.679-.679a.679.679,0,1,0-.96.96Z",
    transform: "translate(-20.478 -13.871)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1167",
    "data-name": "Rectangle 1167",
    width: 24,
    height: 24,
    transform: "translate(-13058 9705)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.14b3020bce753940415e005ff43d225f.svg";
export { ForwardRef as ReactComponent };